import PropTypes from "prop-types";

import { CONTACT_US_EMAIL } from "../../constants";
import Button from "../Button";
import Pill from "../Pill";

import "./statusBanner.scss";

const StatusBanner = ({ status, id, clientQuestionnaireId }) => {
  const isProdEnv = process.env.REACT_APP_ENV === `production`;

  return (
    <div className="status-banner">
      <div className="status-banner__wrapper">
        <div className="status-banner__state">
          <span>Proposal status:</span>
          {status && (
            <Pill
              type={status}
              text={status.charAt(0).toUpperCase() + status.slice(1)}
            />
          )}
        </div>
        <div className="status-banner__action">
          {status === "ready" ? (
            <>
              <Button
                variant="outline"
                size="small"
                href={`/reports/${id}`}
                target="_blank"
                iconName="system-arrow-up-right"
                iconPosition="right"
                iconSize="medium"
              >
                View Report
              </Button>
              {!isProdEnv && (
                <Button
                  className={
                    !clientQuestionnaireId && "status-banner__action__btn-start"
                  }
                  variant="outline"
                  size="small"
                  href={`/client-questionnaires/${
                    clientQuestionnaireId ? clientQuestionnaireId : `add/${id}`
                  }`}
                  iconName="system-arrow-up-right"
                  iconPosition="right"
                  iconSize="medium"
                >
                  {clientQuestionnaireId ? "View" : "Start"} Client
                  Questionnaire
                </Button>
              )}
            </>
          ) : (
            <>
              <span>Want to know more?</span>
              <Button
                variant="outline"
                size="small"
                href={`mailto:${CONTACT_US_EMAIL}`}
                aria-label={`Contact us at ${CONTACT_US_EMAIL}`}
              >
                Contact Us
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

StatusBanner.propTypes = {
  status: PropTypes.string,
  id: PropTypes.string,
  clientQuestionnaireId: PropTypes.string,
};

export default StatusBanner;
